import React from 'react';
import '../../css/ActionButtons.css';
import {
    ArrowLeftIcon,
    CalendarIcon,
    CheckIcon,
    ClockIcon,
    CreditCardIcon,
    EyeIcon,
    FileTextIcon,
    MapPinIcon,
    NewFileIcon,
    PencilIcon,
    PrinterIcon,
    SearchIcon,
    StarIcon,
    UndoCircleIcon,
    UsersIcon,
    WhatsAppIcon,
    XIcon,
} from './actionIcons';
import {withFocusOnClick} from '../../utils/focusUtils';

const VARIANT_CONFIG = {
    new: {className: 'new-button', Icon: NewFileIcon, defaultTitle: 'Novo'},
    edit: {className: 'edit-button', Icon: PencilIcon, defaultTitle: 'Editar'},
    delete: {className: 'remove-button', Icon: XIcon, defaultTitle: 'Excluir'},
    confirm: {className: 'confirm-button', Icon: CheckIcon, defaultTitle: 'Confirmar'},
    reverse: {className: 'finish-button', Icon: UndoCircleIcon, defaultTitle: 'Estornar'},
    search: {className: 'search-button', Icon: SearchIcon, defaultTitle: 'Buscar'},
    availability: {className: 'availability-button', Icon: CalendarIcon, defaultTitle: 'Disponibilidade'},
    view: {className: 'edit-button', Icon: EyeIcon, defaultTitle: 'Ver'},
    'view-customer': {className: 'edit-button', Icon: EyeIcon, defaultTitle: 'Ver cliente'},
    efetivar: {className: 'confirm-button', Icon: CheckIcon, defaultTitle: 'Efetivar'},
    contrato: {className: 'confirm-button', Icon: FileTextIcon, defaultTitle: 'Contrato'},
    entrega: {className: 'confirm-button', Icon: FileTextIcon, defaultTitle: 'Entrega'},
    share: {className: 'confirm-button', Icon: UsersIcon, defaultTitle: 'Compartilhar'},
    'default-template': {className: 'availability-button', Icon: StarIcon, defaultTitle: 'Modelo padrão'},
    maps: {className: 'search-button', Icon: MapPinIcon, defaultTitle: 'Google Maps'},
    time: {className: 'availability-button', Icon: ClockIcon, defaultTitle: 'Alterar horário'},
    term: {className: 'confirm-button', Icon: FileTextIcon, defaultTitle: 'Termo'},
    extend: {className: 'availability-button', Icon: CalendarIcon, defaultTitle: 'Prorrogar'},
    back: {className: 'back-button', Icon: ArrowLeftIcon, defaultTitle: 'Voltar'},
    payments: {className: 'confirm-button', Icon: CreditCardIcon, defaultTitle: 'Pagamentos'},
    print: {className: 'search-button', Icon: PrinterIcon, defaultTitle: 'Imprimir'},
    file: {className: 'confirm-button', Icon: FileTextIcon, defaultTitle: 'Arquivo'},
    whatsapp: {className: 'whatsapp-button', Icon: WhatsAppIcon, defaultTitle: 'WhatsApp'},
    rental: {className: 'rental-button', Icon: CalendarIcon, defaultTitle: 'Cadastrar aluguel'},
    resumo: {className: 'resumo-button', Icon: WhatsAppIcon, defaultTitle: 'Resumo WhatsApp'},
};

const ActionIconButton = ({
    variant,
    title,
    onClick,
    disabled,
    type = 'button',
    className = '',
    style,
    children,
    ...rest
}) => {
    const config = VARIANT_CONFIG[variant];
    if (!config) {
        if (process.env.NODE_ENV !== 'production') {
            console.warn(`ActionIconButton: variant desconhecido "${variant}"`);
        }
        return null;
    }
    const {className: variantClass, Icon, defaultTitle} = config;
    const tooltip = title ?? defaultTitle;

    return (
        <button
            type={type}
            className={`action-icon-button ${variantClass} ${className}`.trim()}
            onClick={withFocusOnClick(onClick)}
            disabled={disabled}
            title={tooltip}
            aria-label={tooltip}
            style={style}
            {...rest}
        >
            <Icon/>
            <span className="action-icon-button__label">{tooltip}</span>
            {children}
        </button>
    );
};

export default ActionIconButton;
